<div class="campaign-button" *ngIf="buttonText && (link || fileUrl)">
  <div class="container">
    <a [href]="link ? link : fileUrl" target="_blank" class="button button-primary" [appBackgroundColor]="'red'">{{ buttonText }}</a>
  </div>
</div>
